import { render, staticRenderFns } from "./TeachingStatistics.vue?vue&type=template&id=7c70e08a&scoped=true"
import script from "./TeachingStatistics.vue?vue&type=script&lang=js"
export * from "./TeachingStatistics.vue?vue&type=script&lang=js"
import style0 from "./TeachingStatistics.vue?vue&type=style&index=0&id=7c70e08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70e08a",
  null
  
)

export default component.exports